import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderPlus02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.103 19.515h-7.8a2.4 2.4 0 0 1-2.4-2.4V4.832a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954h8.317a1.2 1.2 0 0 1 1.2 1.2v3.188m-2.4 9.394v-3.395m0 0V13.58m0 3.394h-3.394m3.394 0h3.394"
    />
  </svg>
);
export default SvgFolderPlus02;
